import { PropertyBrowserNodeOUT } from "api-client";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import PropertyInput from "./PropertyInput";
import { ConditionProps } from "./ConditionRow";
import { rulesSetStore } from "../RulesSetStore";
import { observer } from "mobx-react-lite";
import PropertyBrowserTree from "features/PropertyBrowser/PropertyBrowserTree";
import { usePropertyBrowserStore } from "features/PropertyBrowser/PropertyBrowserStoreContext";

interface PropertyFieldProps {
  onRemoveProperty: () => void;
  row: ConditionProps;
  onSelectProperty: (value: PropertyBrowserNodeOUT) => void;
}

function PropertyField({ row, ...props }: PropertyFieldProps) {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const [propertySearchMode, setPropertySearchMode] = React.useState(false);
  const propertyName = isEng ? row.property?.name : row.property?.name_de;

  const store = usePropertyBrowserStore();
  const defaultGroupId = store.nodeChildren
    .get(null)
    ?.items.find((n) => n.name_de === "Objekteigenschaften")?.node_id;

  React.useEffect(() => {
    setPropertySearchMode(false);
  }, [rulesSetStore.currentRule?.id]);

  const handleOpenPropertyMenu = (state: boolean) => {
    setPropertySearchMode(state);
  };

  const handleRemoveProperty = () => {
    props.onRemoveProperty();
  };

  return (
    <div className="relative w-full">
      <PropertyBrowserTree
        containerClassName="relative"
        optionsClassName="!max-w-fit min-w-[246px]"
        isOpen={handleOpenPropertyMenu}
        disableOpen={!!row.property}
        rootGroupId={defaultGroupId}
        onSelect={(node) => props.onSelectProperty(node)}
        titleOrIcon={
          <PropertyInput
            value={propertyName}
            onChangeSearch={() => undefined}
            onRemoveClicked={handleRemoveProperty}
            isObject={!!propertyName}
            placeholder={t("rulesEditor.selectProperty")}
            searchMode={propertySearchMode}
            hasError={Boolean(!row.property && !rulesSetStore.inProgressRuleID)}
            inputClassName={clsx({ "pointer-events-none": row.property })}
          />
        }
      />
    </div>
  );
}

export default observer(PropertyField);
